var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8004 5.22833C15.0045 3.45237 13.5885 2.02743 11.8176 1.22035C10.0467 0.413275 8.04235 0.279413 6.17984 0.843834C4.31734 1.40826 2.72445 2.63225 1.69946 4.28661C0.674476 5.94096 0.287692 7.91222 0.611539 9.83123C0.935387 11.7502 1.94766 13.4854 3.45879 14.7118C4.96992 15.9381 6.87627 16.5716 8.82085 16.4936C10.7654 16.4155 12.6149 15.6313 14.0229 14.2878C15.4308 12.9442 16.3008 11.1335 16.4698 9.19471L14.907 9.05849C14.7712 10.6171 14.0718 12.0728 12.9399 13.1529C11.808 14.233 10.3212 14.8634 8.75794 14.9261C7.19466 14.9889 5.66211 14.4796 4.44729 13.4937C3.23247 12.5078 2.41869 11.1129 2.15835 9.5702C1.898 8.02748 2.20894 6.44275 3.03294 5.11279C3.85695 3.78283 5.13749 2.79884 6.63479 2.34509C8.13209 1.89134 9.74344 1.99896 11.1671 2.64778C12.5908 3.2966 13.7291 4.44213 14.3689 5.86985L15.8004 5.22833Z",
    fill: "#255986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4983 2.71913L15.2812 6.00067L11.9996 4.78349",
    stroke: "#255986",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset_icon.58d44667722058eb371825ba8ce88b4f.svg";
export { ForwardRef as ReactComponent };